import { badminton, basketball, fussball } from "../code/unsplashImages";
const getDefaultImageForCategory = (categories) => {
    if (!categories || categories.length === 0) {
        return `${process.env.PUBLIC_URL}/images/logo.png`
    }
    const cat = categories[0];
    if (cat === "Badminton") {
        return badminton.path
    }
    if (cat === "Basketball") {
        return basketball.path
    }
    if (["Fußball", "Alte Herren", "Junior:innen", "Senior:innen", "1.Herren", "2.Herren", "3.Herren", "1.Damen"].includes(cat)) {
        return fussball.path
    }
    return `${process.env.PUBLIC_URL}/images/logo.png`

}

export default getDefaultImageForCategory;